export default __webpack_public_path__ + "static/media/$.a4522235.svg";